/*
* <license header>
*/

import React from 'react'
import { View } from '@adobe/react-spectrum'
import { PageHeaderBanner } from './shared/PageHeaderBanner'
import { GitHubConfigSection } from './admin/GitHubConfigSection'
import { AdobeConsoleConfigSection } from './admin/AdobeConsoleConfigSection'
import { OtherCredentialsConfigSection } from './admin/OtherCredentialsConfigSection'

export const Admin = () => (
  <View width="100%" padding="size-400" UNSAFE_style={{ paddingBottom: '2.5rem' }}>
    <PageHeaderBanner
      title="AppBuilder Factory Configuration"
      subtitle="Configure credentials and repository settings to enable AppBuilder Factory capabilities"
    />
    <GitHubConfigSection />
    <AdobeConsoleConfigSection />
    <OtherCredentialsConfigSection />
    </View>
  )
